export const areaConstants = {
    AREA_FETCHING: 'AREA_FETCHING',
    AREA_FETCHED: 'AREA_FETCHED',
    AREA_SUBMITTING: 'AREA_SUBMITTING',
    AREA_SUBMITTED: 'AREA_SUBMITTED',
    GET_AREAS: 'GET_AREAS',
    GET_AREA_BY_ID: 'GET_AREA_BY_ID',
    GET_ACTIVE_AREAS: 'GET_ACTIVE_AREAS',
    GET_ACTIVE_AREAS_WITH_BRANCH:'GET_ACTIVE_AREAS_WITH_BRANCH',
    AREA_RESET: 'AREA_RESET',
}